import './NavigationTab.css';

export type NavigationTabState = 'active' | 'inactive' | 'hover' | 'disabled';

/** Single tab link inside the Navigation bar. Supports active, inactive, hover, and disabled states. */
export type NavigationTabProps = {
  label: string;
  state?: NavigationTabState;
  href?: string;
  onClick?: () => void;
  className?: string;
};

export function NavigationTab({
  label,
  state = 'inactive',
  href = '#',
  onClick,
  className = '',
}: NavigationTabProps) {
  const rootClasses = [
    'spark-navigation-tab',
    `spark-navigation-tab-${state}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  if (state === 'disabled') {
    return (
      <span className={rootClasses} aria-disabled="true">
        {label}
      </span>
    );
  }

  return (
    <a
      className={rootClasses}
      href={href}
      onClick={onClick ? (e) => { e.preventDefault(); onClick(); } : undefined}
      aria-current={state === 'active' ? 'page' : undefined}
    >
      {label}
    </a>
  );
}
